import { themeQuartz, iconSetQuartzLight } from 'ag-grid-community';

export const GRID = {
  theme: themeQuartz.withPart(iconSetQuartzLight).withParams({
    backgroundColor: '#ffffff',
    browserColorScheme: 'light',
    columnBorder: false,
    fontFamily: 'Arial',
    foregroundColor: 'rgb(46, 55, 66)',
    headerBackgroundColor: '#F9FAFB',
    headerFontSize: 14,
    headerFontWeight: 600,
    headerTextColor: '#919191',
    oddRowBackgroundColor: '#D1D1D1',
    rowBorder: false,
    sidePanelBorder: false,
    spacing: 8,
    wrapperBorder: false,
    wrapperBorderRadius: 0
  }),
  rowsPerPageOptions: [10, 20, 50],
  pageSize: 10
};
